
const ConsolidationRoutes = [
  {
    path: '/periodic_consolidations',
    name: 'PeriodicConsolidations',
    meta: { 
      auth: true, 
      roles: ['Director'],
    },
    component: () => import("@/_backoffice/_financial/components/consolidation/ClientsPeriodicConsolidations.vue"),
  },
]

export default ConsolidationRoutes
